import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import "./ProductComponentStyle.css";
import SimilarProductObjectComponent from "./SimilarProductObjectComponent";

/**
 * Component for displaying a list of similar products.
 *
 * @param {Object} similarProductsArray - The array of similar products to display.
 * @param {Function} setSimilarProductsArray - The function to update the array of similar products.
 * @returns {JSX.Element} The SimilarProductsArrayComponent.
 */
const SimilarProductsArrayComponent = ({
  similarProductsArray,
  setSimilarProductsArray,
}) => {
  /**
   * Deletes a product from similarProductsArray based on its id.
   *
   * @param {number} id - The id of the product to delete.
   * @returns {void}
   */
  const handleDelete = (id) => {
    const newSimilarProducts = similarProductsArray.filter(
      (product) => product.id !== id,
    );
    setSimilarProductsArray(newSimilarProducts);
  };

  return (
    <Container
      className="bordered-shadow-container p-3"
      style={{ maxWidth: "100%" }}
    >
      <Row>
        {similarProductsArray && similarProductsArray.length !== 0 ? (
          similarProductsArray.map((product, index) => (
            <Col
              key={index}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="mb-4 d-flex align-items-stretch"
            >
              <SimilarProductObjectComponent
                name={product.name}
                catNum={product.catNum}
                image_url={product.imageUrl}
                onDelete={() => handleDelete(product.id)}
              />
            </Col>
          ))
        ) : (
          <Col>
            <span>Add competing products here...</span>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default SimilarProductsArrayComponent;
